/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
    Button, Checkbox, Input, Tooltip,
} from 'appkit-react';
import { Col, Row, Alert } from 'react-bootstrap';

import '../styles/signup.scss';
import PasswordHints from './PasswordHints';
import PrivacyPolicy from '../../../Terms-Privacy/components/PrivacyPolicy';
import TermsOfUse from '../../../Terms-Privacy/components/TermsOfUse';
import AccountConfirm from './AccountConfirm';

const appTitle = process.env.REACT_APP_TITLE;

const Signup = ({
    email,
    setEmail,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    phoneNumber,
    password,
    setPassword,
    termsAndConditionCheck,
    setTermsAndConditionCheck,
    passwordShown,
    setPasswordShown,
    disableBtn,
    onSave,
    passwordError,
    handlePhoneInput,
    setShowErrorAlert,
    errorMsg,
    showErrorAlert,
    registerUserLoading,
    termsModal,
    setTermsModal,
    privacyModal,
    setPrivacyModal,
    hasAccount,
    userData,
}) => {
    const signupMessage = `Create your ${appTitle} account`;
    if (termsModal) {
        return (
            <TermsOfUse setTermsModal={setTermsModal} />
        );
    }
    if (privacyModal) {
        return (
            <PrivacyPolicy setPrivacyModal={setPrivacyModal} />
        );
    }
    if (hasAccount) {
        return (
            <AccountConfirm userData={userData} />
        );
    }
    return (
        <div style={{ backgroundColor: 'white', overflowX: 'hidden', overflowY: 'hidden' }}>
            <div className="normal-header-container">
                <nav
                    className="a-header-wrapper justify-content-between"
                >
                    <div className="a-brand-container">
                        <div className="a-pwc-logo-grid a-md" />
                        <div className="a-divider" />
                        <span className="font-weight-medium text-nowrap">
                            {appTitle}
                        </span>
                    </div>
                </nav>
            </div>
            <Row>
                <Col
                    md={4}
                    style={{
                        marginLeft: '33%',
                        marginTop: '5rem',
                        marginBottom: '6.75rem',
                    }}
                >
                    <h4 style={{ textAlign: 'center', color: '#474646' }}>
                        {signupMessage}
                    </h4>
                    {showErrorAlert && (
                        <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible="true">{errorMsg}</Alert>
                    )}

                    <div className="true-comply-register-user">
                        <form autoComplete="false">
                            <div className="form-label a-h6">
                                EMAIL
                            </div>
                            <Input
                                type="text"
                                name="email"
                                value={email}
                                onChange={e => { setEmail(e); }}
                                disabled
                            />
                            <div className="form-label a-h6">
                                FIRST NAME
                            </div>
                            <Input
                                type="text"
                                name="firstName"
                                value={firstName}
                                onChange={e => { setFirstName(e); }}
                            />
                            <div className="form-label a-h6">
                                LAST NAME
                            </div>
                            <Input
                                type="text"
                                name="lastName"
                                value={lastName}
                                onChange={e => { setLastName(e); }}
                            />
                            <div className="form-label a-h6">
                                PHONE NUMBER
                            </div>
                            <Input
                                type="text"
                                pattern="/^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/"
                                name="phoneNumber"
                                value={phoneNumber}
                                onChange={e => handlePhoneInput(e)}
                            />
                            <div className="form-label a-h6">
                                PASSWORD
                                <span style={{ float: 'right', marginRight: '0.5rem' }}>
                                    <span
                                        className="appkiticon
                                        icon-view-fill"
                                        style={{ marginRight: '0.3rem', color: passwordShown ? '#474646' : '#D04A02', cursor: 'pointer' }}
                                        onClick={() => setPasswordShown(!passwordShown)}
                                        onKeyDown={() => setPasswordShown(!passwordShown)}
                                        role="button"
                                        tabIndex={0}
                                    />
                                    <span
                                        style={{ color: passwordShown ? '#474646' : '#D04A02', cursor: 'pointer' }}
                                        onClick={() => setPasswordShown(!passwordShown)}
                                        onKeyDown={() => setPasswordShown(!passwordShown)}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        {passwordShown ? 'hide' : 'show'}
                                    </span>
                                </span>
                            </div>
                            <Tooltip
                                content={
                                    <PasswordHints password={password} firstName={firstName} lastName={lastName} />
                                }
                                placement="right"
                                tooltipTheme="light"
                                trigger="click"
                            >
                                <Input
                                    type={passwordShown ? 'text' : 'password'}
                                    name="password"
                                    value={password}
                                    onChange={e => { setPassword(e); }}
                                    onClick={() => PasswordHints(password)}
                                    maxLength="20"
                                    suffix={
                                        passwordError === false ? <span className="appkiticon icon-check-mark-fill a-font-16 a-text-green a-mr-5" aria-hidden="true" /> : null
                                    }
                                />
                            </Tooltip>
                            <div className="true-comply-register-user-check-box">
                                <span>
                                    <Checkbox
                                        checked={termsAndConditionCheck}
                                        onChange={e => { setTermsAndConditionCheck(e.target.checked); }}
                                    />
                                </span>
                                <span style={{ paddingLeft: '0.5rem' }}>
                                    I agree to the&nbsp;
                                    <span
                                        className="hyper-link"
                                        onClick={() => setTermsModal(!termsModal)}
                                        onKeyDown={() => setTermsModal(!termsModal)}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Terms of use&nbsp;
                                    </span>
                                    and&nbsp;
                                    <span
                                        className="hyper-link"
                                        onClick={() => setPrivacyModal(!privacyModal)}
                                        onKeyDown={() => setPrivacyModal(!privacyModal)}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Privacy policy
                                    </span>
                                </span>
                            </div>
                            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                                <Button size="xl" style={{ width: '100%' }} disabled={disableBtn || passwordError} onClick={() => onSave()} isLoading={registerUserLoading}>
                                    CREATE AN ACCOUNT
                                </Button>
                            </div>
                        </form>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Signup;
